import React from 'react';

/**
 * Redirect callbacks loader template
 */
class TemplateLoader extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    if (props.componentDidMount) {
      this.componentDidMount = props.componentDidMount;
    }
  }

  render() {
    return (
      <div className='tp-loader'>
        <div className='tp-loader-rings'>
          <div />
          <div />
          <div />
          <div />
        </div>
        <div className='tp-loader-text'>{this.props.message}</div>
      </div>
    );
  }
}

export default TemplateLoader;
